export class Naics {
    desc1Heading = ""
    desc2Array: Desc2Heading[] = []

    constructor(desc1Heading: string, desc2Array: Desc2Heading[]) {
        this.desc1Heading = desc1Heading
        this.desc2Array = desc2Array
    }
}

export class Desc2Heading {
    desc2Heading = ""
  
 desc3Array:Desc3Heading[]=[]


    
    constructor(desc2Heading: string,desc3Array:Desc3Heading[]) {
        this.desc2Heading = desc2Heading
     
        this.desc3Array=desc3Array

      
       
   

 }
}
export class Desc3Heading {
  desc3Heading=""
  naicCode=""
  desc4 =""
  sicCode=""


    
    constructor(desc3Heading:"",sicCode:"", desc4: "", naicCode: "") {
        this.desc3Heading=desc3Heading

        this.naicCode = naicCode
        this.desc4=desc4
        this.sicCode=sicCode
       
    }
}



